import React from "react";
import { MessageBar, MessageBarType } from "@fluentui/react";

const ErrorComponent = ({ errorMessage, showError, setShowError,isMultiline }) => {

  if (!showError) return null;
  return (
    <MessageBar
      messageBarType={MessageBarType.error}
      isMultiline={isMultiline ? isMultiline : false}
      dismissButtonAriaLabel="Close"
      onDismiss={() => setShowError(false)}
      className="my-1"
    >
      {errorMessage}
    </MessageBar>
  );
};

export default ErrorComponent;
